import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateIngredientAlternativeIngredientsDetailsArgs } from '../graphql/transformers'
import { UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS } from '../redux/action-types'

const useUpdateIngredientAlternativeIngredientsDetailsMutation = () => {
  const dispatch = useDispatch()

  const {
    isAlternativeIngredientsDetailsLoading,
    alternativeIngredientsDetailsError,
  } = useSelector(store => store.ingredients.ingredient)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateIngredientAlternativeIngredientsDetailsArgs(
            data,
          ),
        },
        dispatch,
        UPDATE_INGREDIENT_ALTERNATIVE_INGREDIENTS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isAlternativeIngredientsDetailsLoading,
      error: alternativeIngredientsDetailsError,
    },
  ]
}

export default useUpdateIngredientAlternativeIngredientsDetailsMutation
